import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { blockedMessage } from '../lib/accessBlock';
export function RoleRoute({ allowedRoles }) {
    const { user, logout } = useAuth();
    // Compte sans aucun espace utilisable (habitant, ou agent et pro bloqués) : déconnexion
    // et retour à la connexion avec le motif, au lieu de rediriger sans fin.
    const noSpace = !!user && blockedMessage(user) !== null;
    useEffect(() => { if (noSpace)
        logout(); }, [noSpace, logout]);
    if (!user) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    if (noSpace) {
        return _jsx(Navigate, { to: `/login?blocked=${user.roles.some((r) => ['ROLE_ADMIN_COMMUNE', 'ROLE_OPERATOR', 'ROLE_PRO'].includes(r)) ? (user.agent_blocked ? 'AGENT_BLOCKED' : 'PRO_BLOCKED') : 'NO_ACCESS'}`, replace: true });
    }
    const hasRole = user.roles.some((r) => allowedRoles.includes(r));
    if (!hasRole) {
        // Redirect to the appropriate home for this role (avoids /commune loops for pros).
        if (user.roles.includes('ROLE_SUPER_ADMIN')) {
            return _jsx(Navigate, { to: "/super-admin", replace: true });
        }
        if (user.roles.includes('ROLE_PRO') && !user.roles.includes('ROLE_ADMIN_COMMUNE')) {
            return _jsx(Navigate, { to: "/pro", replace: true });
        }
        return _jsx(Navigate, { to: "/commune", replace: true });
    }
    return _jsx(Outlet, {});
}
